import { Rule, RuleSet } from "ngx-angular-query-builder";
import { FilterFieldProvider } from "./filter-field-provider";
import { FilterOperationsProvider } from "./filter-operations-provider";
import { convertFieldValue } from "./filter-utils";
import { StandardFilterOperations } from "./standard-filter-operations";

export class StandardFilterStrategy<T> {

    constructor(private readonly filterFieldProvider: FilterFieldProvider) {

    }

    convertValue(value: any, actualValue: any, fieldName: string): any {
        const field = this.filterFieldProvider.getFilterField(fieldName);
        if (!field) {
            console.error(`cannot locate field for fieldName ${fieldName} `);
            return { checkValue: '', actualValue: '' };
        }
        return convertFieldValue(value, actualValue, fieldName, field);
    }

    operationsProvider: FilterOperationsProvider = new StandardFilterOperations();

    applyFilterWithDefault(array: Array<T>, filter: RuleSet, defaultFilter: RuleSet): Array<T> {
        if (defaultFilter) {
            const combinedFilter = {
                condition: 'and',
                rules: [defaultFilter, filter]
            } as RuleSet;

            return this.applyFilter(array, combinedFilter);
        }

        return this.applyFilter(array, filter);
    }

    applyFilter(array: Array<T>, filter: RuleSet): Array<T> {

        if (!array?.length || !filter?.rules?.length)
            return array;

        if (filter.condition === 'and') {
            filter.rules.forEach((rule) => {
                if ((rule as RuleSet).rules) {
                    array = this.applyFilter(array, rule as RuleSet);
                } else {
                    const ruleAsRule: Rule = rule as Rule;
                    array = array.filter((item) => {
                        const fieldName = ruleAsRule.field;
                        const valuesToCompare: any = this.convertValue(ruleAsRule.value, item[fieldName], fieldName);
                        return this.operationsProvider.applyOperation(valuesToCompare.actualValue,
                            valuesToCompare.checkValue,
                            ruleAsRule.operator);
                    });
                }
            });
        }
        else if (filter.condition === 'or') {
            let orArray = [];
            filter.rules.forEach((rule) => {
                if ((rule as RuleSet).rules) {
                    const filteredArray = this.applyFilter(array, rule as RuleSet);
                    orArray = orArray.concat(filteredArray);
                } else {
                    const ruleAsRule: Rule = rule as Rule;
                    orArray = orArray.concat(array.filter((item) => {
                        const fieldName = ruleAsRule.field;
                        const valuesToCompare: any = this.convertValue(ruleAsRule.value, item[fieldName], fieldName);
                        return this.operationsProvider.applyOperation(valuesToCompare.actualValue,
                            valuesToCompare.checkValue,
                            ruleAsRule.operator);
                    }));
                }
            });
            return Array.from(new Set(orArray));
        }

        return array;
    }
}
